import React from "react";
import ModalShell from "./ModalShell";

interface Props {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  // "danger" styles the confirm button as a destructive action (red);
  // "primary" uses the standard accent button. Defaults to primary.
  variant?: "danger" | "primary";
  // Optional second (more destructive) choice alongside Confirm — e.g. the
  // round owner's "Delete for everyone" next to "Delete for me". Rendered as a
  // quieter red-text button so it can't be hit by accident.
  extraLabel?: string;
  onExtra?: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

// Reusable confirmation dialog. Used wherever a destructive or
// irreversible action needs an explicit second tap (delete history
// entry, end round, etc.). Renders inside a regular ModalShell so
// stacking on top of other modals just works — the latter backdrop
// is on top, the inner stopPropagation handles click isolation.
export default function ConfirmModal({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "primary",
  extraLabel,
  onExtra,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <ModalShell
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button
            type="button"
            className="cg-btn cg-btn-ghost"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          {extraLabel && onExtra && (
            <button
              type="button"
              className="cg-btn cg-btn-ghost cg-btn-danger-text"
              onClick={onExtra}
            >
              {extraLabel}
            </button>
          )}
          <button
            type="button"
            className={`cg-btn ${
              variant === "danger" ? "cg-btn-danger" : "cg-btn-primary"
            }`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      <p className="cg-confirm-message">{message}</p>
    </ModalShell>
  );
}
